import { TermsViewer } from "pages/terms/TermsViewer";

export const AllTerms = () => {
    return <TermsViewer mode="terms" />;
};
